<div class="organization-logo bg-primary">
    <img *ngIf="organization?.logo_file || organization.logo; else char" [src]="organization?.logo_file?.pathUrlSmall || organization?.logo?.pathUrlSmall" alt="">
    <ng-template #char>
        <div>{{ organization?.name?.charAt(0) | uppercase }}</div>
    </ng-template>
</div>